import React, { Component } from 'react';
import { Flex, Heading, Text, BorderedTab, BorderedTabs } from 'core/components';
import Markdown from '../../journeys/Markdown';
import ToolResultCard from '../components/ToolResultCard';

class RunbookToolResult extends Component {
  state = {
    selectedTabIndex: 0
  };

  handleTabChange = (index) => {
    this.setState({ selectedTabIndex: index });
  };

  render() {
    const { tool, onCloseToolResult, isInlineMode = false } = this.props;
    const { raw_result } = tool;
    const { selectedTabIndex } = this.state;

    if (!raw_result || !Array.isArray(raw_result) || raw_result.length === 0) {
      return (
        <ToolResultCard
          tool={tool}
          onCloseToolResult={onCloseToolResult}
          className="tool-result-runbooks"
          title={tool.title || 'Runbooks'}
          isInlineMode={isInlineMode}
        >
          <Flex p={2} flexDirection="column" gap={2}>
            <Text muted>No runbooks retrieved</Text>
          </Flex>
        </ToolResultCard>
      );
    }

    const runbooks = raw_result;
    const selectedRunbook = runbooks[selectedTabIndex] || runbooks[0];

    return (
      <ToolResultCard
        tool={tool}
        onCloseToolResult={onCloseToolResult}
        className="tool-result-runbooks"
        title={tool.title || 'Runbooks'}
        isInlineMode={isInlineMode}
        overflow="hidden"
      >
        <Flex flexDirection="column" gap={0} height="100%" overflow="hidden">
          {runbooks.length > 1 && (
            <Flex p={2} pt={0} pb={1} borderBottom="thin">
              <BorderedTabs selectedTabIndex={selectedTabIndex} onChange={this.handleTabChange}>
                {runbooks.map((runbook, index) => (
                  <BorderedTab id={index} key={runbook.id || index} title={runbook.name} />
                ))}
              </BorderedTabs>
            </Flex>
          )}

          <Flex flexDirection="column" gap={2} p={2} overflow="auto" flex={1}>
            {runbooks.length === 1 && (
              <Flex flexDirection="column" gap="4px">
                <Text muted small>
                  Runbook Name
                </Text>
                <Heading level={4} m={0} fontSize={18} fontWeight={600}>
                  {selectedRunbook.name}
                </Heading>
              </Flex>
            )}

            {selectedRunbook.description && (
              <Flex flexDirection="column" gap="4px">
                <Text muted small>
                  Description
                </Text>
                <Text>{selectedRunbook.description}</Text>
              </Flex>
            )}

            <Flex flexDirection="column" gap="4px">
              <Text muted small>
                Instructions
              </Text>
              <Markdown>{selectedRunbook.instructions}</Markdown>
            </Flex>
          </Flex>
        </Flex>
      </ToolResultCard>
    );
  }
}

export default RunbookToolResult;
